import WaveLoader from "./WaveLoader";

interface Props {
  message?: string;
}
const ItemLoader = ({ message }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <WaveLoader className="w-[120px]" />
      {message && (
        <span className="block font-normal text-[12px] leading-[19.16px] tracking-[0.02em] text-center text-[#67749B]">
          {message}
        </span>
      )}
    </div>
  );
};

export default ItemLoader;
